import { SyntheticEvent, useContext, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import styled from 'styled-components'
import { FONT_MIME_TYPES } from '../../../constants'
import CreationToolGradient from '../../../types/gradient'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { convertS3UrlToCdn } from '../../../utils/upload'
import { GradientButton } from '../../buttons'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import API from '../../supercut/shared/utils/api'
import FieldTitle from './field-title'
import UserContext from 'shared/contexts/user'
import MessageContext from 'shared/contexts/message'

const api = new API()

const Container = styled.div`
    grid-column: span 2;
`

const FileButton = styled(GradientButton)`
    height: 36px;
    margin-right: 30px;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureFontFileField = ({ field }: Props) => {
    const { setFont, previousFonts, setPreviousFonts } = useContext(CreationCaptureInfoContext)
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useContext(UserContext)
    const { sendMessage } = useContext(MessageContext)

    const onFileInput = async (e: SyntheticEvent<HTMLInputElement, Event>) => {
        const { files } = e.currentTarget
        if (files) {
            setIsLoading(true)
            try {
                const file = files[0]
                const fontUpload = await api.uploadCaptureAsset(
                    file,
                    file.name.split('.')[1],
                    CreationToolSuperCutField.s3BucketPrefix(field)!
                )
                const fontCdnUrl = convertS3UrlToCdn(
                    fontUpload.fullUrl,
                    CreationToolSuperCutField.s3BucketPrefix(field)!
                )
                const newFontId = fontUpload.key
                    .replace(`${CreationToolSuperCutField.s3BucketPrefix(field)!}/`, '')
                    .split('.')[0]
                const newFont = { filename: file.name, fontUrl: fontCdnUrl, id: newFontId }
                await api.uploadFont(user.username, fontCdnUrl, file.name)

                setFont(newFont)
                setPreviousFonts([newFont, ...previousFonts])
                setIsLoading(false)
            } catch (e) {
                sendMessage(`Unable to upload font. Please refresh and try again.`, 'error')
                setIsLoading(false)
            }
        }
    }

    return (
        <Container>
            {isLoading ? (
                <DotsLoader />
            ) : (
                <>
                    <FieldTitle field={field} />
                    <FileButton colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}>
                        Choose a File
                        <input type="file" accept={FONT_MIME_TYPES.join(',')} onInput={onFileInput} />
                    </FileButton>
                </>
            )}
        </Container>
    )
}

export default CreationCaptureFontFileField
